import React from "react";
import { useSelector } from "react-redux";
import Chatbot from "./Chatbot";

function ChatbotGate() {
  const isSignedIn = useSelector((state) => state.auth.isSignedIn);

  if (!isSignedIn) {
    return null;
  }

  return <Chatbot />;
}

export default ChatbotGate;
